var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-1 pt-1 py-xl-5",class:{ 'py-3': _vm.$route.name !== 'chat-detail' }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }